import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import FilterRequest from '../../../Spirit/Common/Extensions/Models/FilterRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import PaginationResponseT from '../../../Common/ResponseModels/PaginationResponseT';
import UsersGetListResponse from '../../../Spirit/Admin/Interfaces/Models/UserService/UsersGetListResponse';

export default class UserService {
	webApiService: WebApiService;
	GetListEvent = new Events<WsResponseModelT<PaginationResponseT<UsersGetListResponse>>>();
	ToggleIsBlockedEvent = new Events<WsResponseModelT<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('UserService', 'GetList', (res: WsResponseModelT<PaginationResponseT<UsersGetListResponse>>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('UserService', 'ToggleIsBlocked', (res: WsResponseModelT<Boolean>) => {
			self.ToggleIsBlockedEvent.trigger(res);
		});
	}
	GetList(request: FilterRequest = null) { 	
        this.webApiService.send('UserService', 'GetList' , request);
    }
	ToggleIsBlocked(userId: number = 0) { 	
        this.webApiService.send('UserService', 'ToggleIsBlocked' , userId);
    }
	 // async methods
	async getListAsync(request: FilterRequest = null): Promise<PaginationResponseT<UsersGetListResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
	async toggleIsBlockedAsync(userId: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ToggleIsBlocked.bind(this), this.ToggleIsBlockedEvent)(userId);
	}
}